/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    func, object, bool, string, number,
} from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { CalendarDays } from 'lucide-react';
import { format } from 'date-fns';
import isPastCutoff from '../../../../helpers/determineCutoffTime';
import { trackEvent } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getFeatureFlag } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
/* eslint-disable no-restricted-globals */

const styles = (theme) => ({
    todayTomorrowWrapper: {
        display: 'flex',
    },
    buttonToday: {
        marginRight: '10px',
        width: '55%',
        // height: '52px',
        color: 'white',
        fontSize: '16px',
        textAlign: 'center',
        lineHeight: '52px',
        background: theme.palette.cms?.flowerPdpButton || '#185357',
        border: 'none',
        outline: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        '&:active': {
            background: theme.palette.cms?.flowerPdpButtonActive || '#185357',
        },
        '&:focus': {
            // TODO: Handle outline for accesibility
        },
        '&:disabled': {
            opacity: 0.6,
            cursor: 'not-allowed',
        },
        [theme.breakpoints.down('768')]: {
            fontSize: '14px',
        },
        [theme.breakpoints.down('340')]: {
            marginRight: 5,
        },
    },
    buttonTomorrow: {
        marginRight: '10px',
        width: '55%',
        // height: '52px',
        color: 'white',
        fontSize: '16px',
        textAlign: 'center',
        lineHeight: '52px',
        background: theme.palette.cms?.flowerPdpButton || '#185357',
        border: 'none',
        borderRadius: '4px',
        outline: 'none',
        cursor: 'pointer',
        '&:active': {
            background: theme.palette.cms?.flowerPdpButtonActive || '#185357',
        },
        '&:disabled': {
            opacity: 0.6,
            cursor: 'not-allowed',
        },
        [theme.breakpoints.down('768')]: {
            fontSize: '14px',
        },
        [theme.breakpoints.down('340')]: {
            marginRight: 5,
        },
    },
    buttonCalendar: {
        fontFamily: 'museo-sans, "Area Variable"',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        // height: '52px',
        color: 'white',
        fontSize: '16px',
        textAlign: 'center',
        lineHeight: '52px',
        background: theme.palette.cms?.flowerPdpButton || '#185357',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        '&> svg': {
            marginLeft: '8px',
            width: '19px',
        },
        '&:active': {
            background: theme.palette.cms?.flowerPdpButtonActive || '#185357',
        },
        '&:disabled': {
            opacity: 0.6,
            cursor: 'not-allowed',
        },
    },
    buttonCalendarV2: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        // height: '52px',
        color: 'white',
        fontSize: '18px',
        textAlign: 'center',
        lineHeight: '52px',
        background: '#E80A4D',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontFamily: 'Poppins',
        fontWeight: 700,
        letterSpacing: '0.01em',
        textTransform: 'uppercase',
        '&> svg': {
            marginLeft: '8px',
            width: '19px',
        },
        '&:active': {
            background: '#790000',
        },
        '&:disabled': {
            opacity: 0.6,
            cursor: 'not-allowed',
        },
    },
    buttonFont: {
        fontWeight: 700,
        fontFamily: 'museo-sans, "Area Variable", Lato, Arial, sans-serif',
    },
    btnPill: {
        borderRadius: 24,
        height: 48,
        fontSize: 16,
        fontWeight: 'bold',
        [theme.breakpoints.down(768)]: {
            textTransform: 'uppercase',
        },
    },
    fullCalendar: {
        [theme.breakpoints.down('768')]: {
            fontSize: '14px',
        },
    },
    buttonWrapper: {
        flexDirection: 'column',
        '& button': {
            width: '100%',
            borderRadius: '3px',
            fontSize: '18px',
            lineHeight: '26px',
            minHeight: '56px',
            marginBottom: '8px',
            textTransform: 'capitalize',
            [theme.breakpoints.up('600')]: {
                marginBottom: '16px',
            },
        },
    },
    redesignButtonCalendar: {
        '& $buttonToday, $buttonTomorrow, $buttonCalendar, $buttonCalendarV2': {
            background: theme.palette.primary.main || '#201648',
            '&:active': {
                background: theme.palette.primary.main || '#201648',
            },
        },
    },
    caPriceRange: {
        marginLeft: '5px',
    },
    caPriceContainer: {
        textAlign: 'center',
    },
    caDynamicPrice: {
        color: '#000',
        fontSize: 'var(--fontSizes-fontHeader5DT, 20px)',
        fontStyle: 'normal',
        fontWeight: '700',
        lineHeight: 'var(--lineHeights-lineHeader5DT, 25px)',
        letterSpacing: '0.2px',
        paddingBottom: '16px',
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.down('600')]: {
            fontSize: 'var(--fontSizes-fontHeader6, 16px)',
            lineHeight: 'var(--lineHeights-lineHeader6, 21px)',
        },
    },
    deliveryMsg: {
        paddingLeft: '5px',
    },
    priceAddon: {
        paddingLeft: '5px',
    },
    stickyAtcWrapper: {
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1300,
        backgroundColor: '#fff',
        boxShadow: '0px -2px 20px 0px #0000002E',
        padding: '12px',
        paddingBottom: 'calc(12px + env(safe-area-inset-bottom, 0px))',
    },
    stickyAtcButton: {
        width: '100%',
        minHeight: '52px',
        borderRadius: '4px',
        border: 'none',
        cursor: 'pointer',
        color: 'white',
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 700,
        background: theme.palette.cms?.flowerPdpButton || '#201648',
        '&:active': {
            background: theme.palette.cms?.flowerPdpButtonActive || '#201648',
        },
        '&:disabled': {
            opacity: 0.6,
            cursor: 'not-allowed',
        },
    },
    hiddenInlineAtc: {
        display: 'none',
    },
});

const DeliveryCalendarButtonContainer = ({
    classes,
    addTodayOrTomToCart,
    fullCalendarCall,
    zipValid,
    productDeliveryType,
    isInternationalProduct,
    todayTomorrowFlagEnabled,
    displayDeliveryCalendar,
    deliveryCalendarEnable,
    pmallAddToCartDisabled,
    vaseConfiguratorDisabled,
    isGPTCalendarButtonTextTestActive,
    presentationFamily,
    isPdpRedesignEnabled,
    addToCartButtonRedesign,
    selectedSku,
    deliveryDateOptionsFlagEnabled,
    deliveryDateOption,
    variantDeliveryOptions,
    dateSelectedFromCalendar,
    deliveryDateOptionsFlexDetails,
    flexTodayTomorrowAddToCart,
    updatePersonalizationState,
    personalizationAdded,
    flexDetailsAvailable,
    locationType,
    isCaDelivery,
    addToCartPriceShow,
    isDeliverCharges,
    zipField,
    addonVariant,
    addToCartPrice,
    stickyAtcEnabled,
    suppressStickyAtc,
}) => {
    const renderTodayTomorrow = todayTomorrowFlagEnabled && !isInternationalProduct && !isPastCutoff() && productDeliveryType === 'FPT' && displayDeliveryCalendar;
    const isFood = presentationFamily === 'food';
    const [isOffScreen, setIsOffScreen] = useState(false);
    const dispatch = useDispatch();
    const cartIconLabel = useSelector(getFeatureFlag(['cart-icon-label']));
    const calendarIconOnButton = deliveryDateOptionsFlagEnabled && variantDeliveryOptions ? '' : <CalendarDays />;
    const canRenderStickyATC = !isInternationalProduct && !(renderTodayTomorrow || (productDeliveryType === 'GPT' && isGPTCalendarButtonTextTestActive));
    const stickyButtonDisabled = (zipValid === false || pmallAddToCartDisabled || vaseConfiguratorDisabled || (zipField === '00000' && !isInternationalProduct));
    const shouldUseStickyMode = stickyAtcEnabled && canRenderStickyATC;
    const shouldShowStickyATC = shouldUseStickyMode && !suppressStickyAtc;

    useEffect(() => {
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            const handleScroll = () => {
                const button = document.getElementById('addToCartBtn');
                if (button) {
                    const rect = button.getBoundingClientRect();
                    const hasDisappeared = rect.top < 0 || rect.bottom > window.innerHeight;
                    setIsOffScreen(hasDisappeared);
                }
            };
            if (isOffScreen) {
                dispatch(trackEvent({
                    eventCategory: 'Product Page',
                    eventAction: 'Scroll',
                    eventName: 'feature_interaction',
                    feature_detail: 'Scroll past Add to Cart button',
                    feature_element: 'Scroll',
                    feature_category: 'Product Page',
                }));
            }
            window.addEventListener('scroll', handleScroll);
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }
        return null;
    }, [isOffScreen]);

    const handleOnClick = (todayTomorrow) => {
        const dateSelected = dateSelectedFromCalendar?.data?.deliveryDate || format(new Date(), 'yyyy-MM-dd');
        const pickedDate = dateSelected.split('-').join('/');
        const formattedPickedDate = format(new Date(pickedDate), 'yyyy-MM-dd');
        // user selected today option before cutoff
        if (deliveryDateOptionsFlagEnabled && variantDeliveryOptions && todayTomorrow === 'today') {
            if (flexDetailsAvailable && locationType !== 'Funeral home' && locationType !== 'Church') {
                return flexTodayTomorrowAddToCart(deliveryDateOptionsFlexDetails);
            }
            if (selectedSku.personalization?.lines?.length && selectedSku.personalization?.indicator && selectedSku.personalization.indicator !== '0') {
                // if the item requires personalization then pause the execution of this function and open
                // personalization modal
                return updatePersonalizationState();
            }
            return addTodayOrTomToCart('today');
        }
        // user selected tomorrow option before cutoff
        if (deliveryDateOptionsFlagEnabled && variantDeliveryOptions && todayTomorrow === 'tomorrow') {
            if (selectedSku.personalization?.lines?.length && selectedSku.personalization?.indicator && selectedSku.personalization.indicator !== '0') {
                // if the item requires personalization then pause the execution of this function and open
                // personalization modal
                return updatePersonalizationState();
            }
            return addTodayOrTomToCart('tomorrow');
        }
        // render calendar
        if (deliveryDateOptionsFlagEnabled && variantDeliveryOptions && todayTomorrow === 'Pick a Date') {
            return addTodayOrTomToCart(formattedPickedDate);
        }
        // this fill fire with next day and day after tomorrow after cutoff time
        if (deliveryDateOptionsFlagEnabled && variantDeliveryOptions && !(todayTomorrow === 'today' || todayTomorrow === 'tomorrow' || todayTomorrow === 'Pick a Date' || todayTomorrow === '')) {
            if (flexDetailsAvailable && locationType !== 'Funeral home' && locationType !== 'Church') {
                return flexTodayTomorrowAddToCart(deliveryDateOptionsFlexDetails);
            }
            if (selectedSku.personalization?.lines?.length && selectedSku.personalization?.indicator && selectedSku.personalization.indicator !== '0' && !personalizationAdded) {
                // if the item requires personalization then pause the execution of this function and open
                // personalization modal
                return updatePersonalizationState();
            }
            return addTodayOrTomToCart(todayTomorrow);
        }
        // if flag is on and test is control
        if (deliveryDateOptionsFlagEnabled && !variantDeliveryOptions) {
            fullCalendarCall();
        }
        // if delviery date options flag is off
        return fullCalendarCall();
    };
    return (
        <>
            <div className={`${classes.todayTomorrowWrapper} ${isPdpRedesignEnabled ? classes.buttonWrapper : ''} ${addToCartButtonRedesign ? classes.redesignButtonCalendar : ''} ${shouldUseStickyMode ? classes.hiddenInlineAtc : ''}`} id="addToCartBtn">
                {isCaDelivery && !isNaN(addToCartPriceShow) ? <div className={classes.caDynamicPrice}>${addToCartPriceShow}<span className={classes.deliveryMsg}> {isDeliverCharges ? 'with delivery fee' : 'plus shipping'}</span></div> : ''}
                {renderTodayTomorrow ? (
                    <>
                        <button
                            type="button"
                            data-test="pdp-today-button"
                            id="today-button"
                            name="todayButton"
                            className={classes.buttonToday}
                            disabled={(zipValid === false) || vaseConfiguratorDisabled}
                            onClick={() => { addTodayOrTomToCart('today'); }}
                        >
                            Today
                        </button>
                        <button
                            type="button"
                            data-test="pdp-tomorrow-button"
                            id="tomorrow-button"
                            name="tomorrowButton"
                            className={classes.buttonTomorrow}
                            disabled={(zipValid === false) || vaseConfiguratorDisabled}
                            onClick={() => { addTodayOrTomToCart('tomorrow'); }}
                        >
                            Tomorrow
                        </button>
                    </>
                ) : null}
                {
                    /* eslint-disable no-nested-ternary */
                    // The logic of the nested ternary below:
                    // First part of ternary:
                    // if the product is internation then display the calendar button with the text Pick A Delivery Date
                    // Second part of ternary:
                    // if the product is not international and we are currently displaying the today / tomorrow buttons
                    // calendar button text is Full Calendar
                    // if the product is not international if we are not displaying today / tomorrow buttons
                    // calendar button text is Add to Cart
                    isInternationalProduct ? (
                        <button
                            type="button"
                            id="btn-full-calendar"
                            data-test="pdp-btn-full-calendar"
                            name="fullCalendarButton"
                            className={classes.buttonCalendar}
                            onClick={() => { fullCalendarCall(); }}
                        >
                            Pick A Delivery Date
                        </button>
                        /* eslint-disable no-nested-ternary */
                    ) : (renderTodayTomorrow || (productDeliveryType === 'GPT' && isGPTCalendarButtonTextTestActive)) ? (
                        <button
                            type="button"
                            id="btn-full-calendar"
                            data-test="pdp-btn-full-calendar"
                            name="fullCalendarButton"
                            className={`${classes.buttonCalendar} ${classes.fullCalendar}`}
                            disabled={(zipValid === false || vaseConfiguratorDisabled)}
                            onClick={() => { fullCalendarCall(); }}
                        >
                            Full Calendar <CalendarDays />
                        </button>
                    ) : (
                        <>
                            <button
                                type="button"
                                id="btn-full-calendar"
                                data-test="pdp-btn-full-calendar"
                                data-testid="pdp-btn-full-calendar"
                                name="fullCalendarButton"
                                className={deliveryCalendarEnable && displayDeliveryCalendar ? `${classes.buttonCalendarV2} ${isFood ? classes.btnPill : ''}` : `${classes.buttonCalendar} ${isFood ? classes.btnPill : ''} ${classes.buttonFont}`}
                                disabled={(zipValid === false || pmallAddToCartDisabled || vaseConfiguratorDisabled || (zipField === '00000' && !isInternationalProduct))}
                                onClick={() => { handleOnClick(deliveryDateOption); }}
                            >
                                Add to {cartIconLabel?.label || 'Cart'} {addonVariant && !isCaDelivery && !isNaN(addToCartPrice) ? <span className={classes.priceAddon}>- ${addToCartPrice}</span> : ''}
                                {deliveryCalendarEnable && displayDeliveryCalendar ? (
                                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.54941 9H7.12966V10.6H5.54941V9ZM16.6111 4.2V15.4C16.6111 16.288 15.9079 17 15.0309 17H3.96916C3.55006 17 3.14811 16.8314 2.85176 16.5314C2.55541 16.2313 2.38892 15.8243 2.38892 15.4V4.2C2.38892 3.32 3.10003 2.6 3.96916 2.6H4.75929V1H6.33953V2.6H12.6605V1H14.2408V2.6H15.0309C15.45 2.6 15.8519 2.76857 16.1483 3.06863C16.4446 3.36869 16.6111 3.77565 16.6111 4.2ZM3.96916 5.8H15.0309V4.2H3.96916V5.8ZM15.0309 15.4V7.4H3.96916V15.4H15.0309ZM11.8704 10.6V9H13.4506V10.6H11.8704ZM8.7099 10.6V9H10.2902V10.6H8.7099ZM5.54941 12.2H7.12966V13.8H5.54941V12.2ZM11.8704 13.8V12.2H13.4506V13.8H11.8704ZM8.7099 13.8V12.2H10.2902V13.8H8.7099Z" fill="white" />
                                    </svg>
                                ) : calendarIconOnButton}
                            </button>
                        </>
                    )
                }
            </div>
            {shouldShowStickyATC ? (
                <div className={classes.stickyAtcWrapper}>
                    <button
                        type="button"
                        data-testid="pdp-sticky-atc"
                        className={classes.stickyAtcButton}
                        disabled={stickyButtonDisabled}
                        onClick={() => { handleOnClick(deliveryDateOption); }}
                    >
                        Add to {cartIconLabel?.label || 'Cart'}
                    </button>
                </div>
            ) : null}
        </>

    );
};

DeliveryCalendarButtonContainer.propTypes = {
    classes: object.isRequired,
    addTodayOrTomToCart: func.isRequired,
    fullCalendarCall: func.isRequired,
    zipValid: bool,
    productDeliveryType: string.isRequired,
    isInternationalProduct: bool.isRequired,
    todayTomorrowFlagEnabled: bool.isRequired,
    displayDeliveryCalendar: bool.isRequired,
    deliveryCalendarEnable: bool.isRequired,
    pmallAddToCartDisabled: bool,
    isGPTCalendarButtonTextTestActive: bool,
    vaseConfiguratorDisabled: bool,
    presentationFamily: string,
    isPdpRedesignEnabled: bool,
    addToCartButtonRedesign: bool,
    selectedSku: object,
    deliveryDateOptionsFlagEnabled: bool.isRequired,
    deliveryDateOption: string.isRequired,
    variantDeliveryOptions: bool.isRequired,
    dateSelectedFromCalendar: object.isRequired,
    deliveryDateOptionsFlexDetails: object.isRequired,
    flexTodayTomorrowAddToCart: func.isRequired,
    updatePersonalizationState: func.isRequired,
    personalizationAdded: bool.isRequired,
    flexDetailsAvailable: bool.isRequired,
    locationType: string.isRequired,
    addToCartPriceShow: object,
    isCaDelivery: bool,
    isDeliverCharges: bool,
    zipField: string,
    addonVariant: bool,
    addToCartPrice: number,
    stickyAtcEnabled: bool,
    suppressStickyAtc: bool,
};

DeliveryCalendarButtonContainer.defaultProps = {
    zipValid: null,
    pmallAddToCartDisabled: false,
    isGPTCalendarButtonTextTestActive: false,
    vaseConfiguratorDisabled: false,
    presentationFamily: '',
    isPdpRedesignEnabled: false,
    addToCartButtonRedesign: false,
    selectedSku: {},
    addToCartPriceShow: null,
    isCaDelivery: false,
    isDeliverCharges: false,
    zipField: '',
    addonVariant: false,
    addToCartPrice: '',
    stickyAtcEnabled: false,
    suppressStickyAtc: false,
};

export default withStyles(styles)(DeliveryCalendarButtonContainer);
